import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from 'contexts/AuthContext';
import CalendarFilter from '../../common/calendar/CalendarFilter';
import PropTypes from 'prop-types';

const InsightsMenu = ({ onDateRangeChange, dateRange }) => {
    const { authState } = useAuth();

    const userName = authState?.user?.fullName || 'User';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 2,
                mb: 3
            }}
        >
            <Typography variant="h6" component="h1">
                Welcome {userName}
            </Typography>

            <CalendarFilter
                onDateRangeChange={onDateRangeChange}
                initialDateRange={dateRange}
            />
        </Box>
    );
};

InsightsMenu.propTypes = {
    onDateRangeChange: PropTypes.func,
    dateRange: PropTypes.array
};

export default InsightsMenu;